import { Controller } from "@hotwired/stimulus"

/**
 * Selection Loader controller - Dynamically loads content based on selection changes
 * 
 * Usage:
 *   <div data-controller="selection-loader">
 *     <select data-turbo-frame="my-frame" 
 *             data-turbo-param="filter" 
 *             data-action="change->selection-loader#load">
 *     </select>
 *   </div>
 *   <turbo-frame id="my-frame">...</turbo-frame>
 * 
 * Attributes:
 *   data-turbo-frame: ID of the turbo frame to update
 *   data-turbo-param: URL parameter name (defaults to input's name attribute)
 *   data-action: Stimulus action binding
 */
export default class extends Controller {
  // Load content based on selection change
  load(event) {
    const input = event.target
    const value = input.value
    const frameId = input.dataset.turboFrame
    const paramName = input.dataset.turboParam || input.name
    
    if (!frameId) return
    
    // Get the current URL and update the parameter
    const url = new URL(window.location.href)
    
    if (value === '' || value === '0' || value === null) {
      url.searchParams.delete(paramName)
    } else {
      url.searchParams.set(paramName, value)
    }
    
    // Navigate the turbo frame to the new URL
    const frame = document.getElementById(frameId)
    if (frame) {
      frame.src = url.toString()
    }
  }
  
  // Alias methods for flexibility
  updateFrame(event) {
    this.load(event)
  }
  
  submitForm(event) {
    this.load(event)
  }
}